import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadges = ({ currentLanguage }) => {
  const securityFeatures = [
    {
      icon: 'Shield',
      title: currentLanguage === 'fr' ? 'Sécurisé SSL' : 'SSL Secured',
      description: currentLanguage === 'fr' ? 'Connexion cryptée' : 'Encrypted connection'
    },
    {
      icon: 'Lock',
      title: currentLanguage === 'fr' ? 'Données protégées' : 'Data Protected',
      description: currentLanguage === 'fr' ? 'Informations sécurisées' : 'Information secured'
    },
    {
      icon: 'UserCheck',
      title: currentLanguage === 'fr' ? 'Vérification ID' : 'ID Verification',
      description: currentLanguage === 'fr' ? 'Identité vérifiée' : 'Identity verified'
    }
  ];

  return (
    <div className="space-y-4">
      {/* Anti-fraud Warning */}
      <div className="bg-warning/10 border border-warning/20 rounded-lg p-4">
        <div className="flex items-start space-x-3">
          <Icon name="AlertTriangle" size={20} className="text-warning mt-0.5" />
          <div>
            <h4 className="font-medium text-warning mb-1">
              {currentLanguage === 'fr' ? 'Protection Anti-Fraude' : 'Anti-Fraud Protection'}
            </h4>
            <p className="text-sm text-muted-foreground">
              {currentLanguage === 'fr' ?'AutoCasse ne demande jamais vos mots de passe par téléphone ou email. Méfiez-vous des tentatives de phishing.' :'AutoCasse never asks for passwords via phone or email. Beware of phishing attempts.'
              }
            </p>
          </div>
        </div>
      </div>
      {/* Security Features */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {securityFeatures?.map((feature, index) => (
          <div key={index} className="flex items-center space-x-2 p-3 bg-card border border-border rounded-lg">
            <div className="w-8 h-8 bg-success/10 rounded-full flex items-center justify-center">
              <Icon name={feature?.icon} size={14} className="text-success" />
            </div>
            <div>
              <div className="text-xs font-medium text-foreground">{feature?.title}</div>
              <div className="text-xs text-muted-foreground">{feature?.description}</div>
            </div>
          </div>
        ))}
      </div>
      {/* Trust Indicators */}
      <div className="flex items-center justify-center space-x-4 pt-2">
        <div className="flex items-center space-x-1">
          <div className="w-2 h-2 bg-success rounded-full animate-pulse"></div>
          <span className="text-xs text-success font-medium">
            {currentLanguage === 'fr' ? 'Connexion sécurisée' : 'Secure connection'}
          </span>
        </div>
        <div className="text-xs text-muted-foreground">
          {currentLanguage === 'fr' ? '256-bit SSL' : '256-bit SSL'}
        </div>
      </div>
    </div>
  );
};

export default SecurityBadges;